import React from 'react';
import { motion } from 'framer-motion';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function PrivacyPolicy() {
  return <div className="w-full bg-white" data-id="element-633" data-mp="qcwe851lmuuc">
      {/* Header */}
      <section className="bg-charcoal pt-20 pb-16 px-4" data-id="element-634" data-mp="mat0f9rgje5w">
        <div className="max-w-4xl mx-auto text-center" data-id="element-635" data-mp="1izh6d7pwfayy">
          <motion.h1 initial="hidden" animate="visible" variants={fadeInUp} className="text-4xl md:text-5xl font-heading font-extrabold text-white uppercase tracking-tight mb-4" data-id="element-636" data-mp="1iyz0djdfpidu">
            Privacy <span className="text-brand-red" data-id="element-637" data-mp="158lvxqzr4lt9">Policy</span>
          </motion.h1>
          <motion.p initial="hidden" animate="visible" variants={fadeInUp} className="text-steel-300 font-body" data-id="element-638" data-mp="156j20vvha8j9">
            Last Updated:{' '}
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            year: 'numeric'
          })}
          </motion.p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-4" data-id="element-639" data-mp="3rglryz5sdpm8">
        <motion.div initial="hidden" animate="visible" variants={fadeInUp} className="max-w-3xl mx-auto prose prose-steel prose-headings:font-heading prose-headings:uppercase prose-headings:font-bold prose-h2:text-2xl prose-h2:text-charcoal prose-h2:mt-12 prose-h2:mb-4 prose-p:text-steel-600 prose-p:leading-relaxed prose-li:text-steel-600" data-id="element-640" data-mp="3rfkjn2g5nh87">
          <p data-id="element-641" data-mp="38ij78wk9ueu8">
            At Merem Mobile Dustless Blasting Michigan, LLC ("Merem Blasting",
            "we", "us", or "our"), we respect your privacy and are committed to
            protecting your personal information. This Privacy Policy explains
            how we collect, use, and safeguard your information when you visit
            our website (meremblasting.com) or use our services.
          </p>

          <h2 data-id="element-642" data-mp="1a93og1verwi7">1. Information We Collect</h2>
          <p data-id="element-643" data-mp="1a5y0ipyin0o2">
            We may collect personal information that you voluntarily provide to
            us when you:
          </p>
          <ul data-id="element-644" data-mp="109csdvr799g0">
            <li data-id="element-645" data-mp="10b5ztd9mzxp2">Request a quote or estimate through our contact forms</li>
            <li data-id="element-646" data-mp="w918wmakpf64">Call or text our business phone numbers</li>
            <li data-id="element-647" data-mp="wam5sikd1a75">
              Communicate with us via email or social media (e.g., Facebook)
            </li>
          </ul>
          <p data-id="element-648" data-mp="1nzpcs63msynh">
            This information may include your name, email address, phone number,
            physical address/project location, and details or photos regarding
            your project.
          </p>

          <h2 data-id="element-649" data-mp="1f7x5235zs3ml">2. How We Use Your Information</h2>
          <p data-id="element-650" data-mp="1f757imsu3vto">
            We use the information we collect primarily to provide and improve
            our services. Specifically, we may use your information to:
          </p>
          <ul data-id="element-651" data-mp="26xrt7wi45n9o">
            <li data-id="element-652" data-mp="26x9yj4b3nh3v">Respond to your inquiries and provide accurate estimates</li>
            <li data-id="element-653" data-mp="3pmml5npzo5jx">
              Schedule and perform mobile blasting services at your location
            </li>
            <li data-id="element-654" data-mp="3ukxu7w8gmc13">Communicate with you regarding your project status</li>
            <li data-id="element-655" data-mp="2gc2fnb7804x">
              Send administrative information, such as invoices or policy
              updates
            </li>
          </ul>

          <h2 data-id="element-656" data-mp="7dlpiwb47zpl">3. Information Sharing and Disclosure</h2>
          <p data-id="element-657" data-mp="cfkta7aroyn2">
            We do not sell, trade, or rent your personal information to third
            parties. We may share your information only in the following
            situations:
          </p>
          <ul data-id="element-658" data-mp="m5nl4465k6jt">
            <li data-id="element-659" data-mp="m5w1i61hhtzr">
              <strong data-id="element-660" data-mp="m5e2x2rcn3oo">Service Providers:</strong> We may share data with trusted
              third-party vendors who assist us in operating our website,
              conducting our business, or servicing you (e.g., invoicing
              software), so long as those parties agree to keep this information
              confidential.
            </li>
            <li data-id="element-661" data-mp="mgv9ljla2fak">
              <strong data-id="element-662" data-mp="mglkrzbyye6g">Legal Requirements:</strong> We may disclose your
              information when required by law, court order, or governmental
              regulation.
            </li>
          </ul>

          <h2 data-id="element-663" data-mp="w653n4zom81b">4. Data Security</h2>
          <p data-id="element-664" data-mp="w9aryi0hl5vz">
            We implement reasonable security measures to maintain the safety of
            your personal information. However, please note that no method of
            transmission over the Internet or method of electronic storage is
            100% secure. While we strive to protect your personal information,
            we cannot guarantee its absolute security.
          </p>

          <h2 data-id="element-665" data-mp="dem08x1qwryr">5. Third-Party Links</h2>
          <p data-id="element-666" data-mp="8hm5hiacjbmy">
            Our website may contain links to third-party websites (such as our
            Facebook page). We are not responsible for the privacy practices or
            the content of these third-party sites. We encourage you to read the
            privacy policies of any linked websites you visit.
          </p>

          <h2 data-id="element-667" data-mp="1reyx5kg2va18">6. Changes to This Privacy Policy</h2>
          <p data-id="element-668" data-mp="1wfd8bbcz703h">
            We may update this Privacy Policy from time to time to reflect
            changes in our practices or for other operational, legal, or
            regulatory reasons. Any changes will be posted on this page with an
            updated revision date.
          </p>

          <h2 data-id="element-669" data-mp="2a7b82vksrjmz">7. Contact Us</h2>
          <p data-id="element-670" data-mp="2a82rz9517sxf">
            If you have any questions or concerns about this Privacy Policy or
            our data practices, please contact us at:
          </p>
          <p data-id="element-671" data-mp="21epq3hozpgz7">
            <strong data-id="element-672" data-mp="21f9ar660yjgx">Merem Mobile Dustless Blasting Michigan, LLC</strong>
            <br data-id="element-673" data-mp="21cwt6u46ib4e" />
            Fowlerville, MI
            <br data-id="element-674" data-mp="25f9oeolauqmx" />
            Phone: (517) 777-8088
          </p>
        </motion.div>
      </section>
    </div>;
}